import React from "react";
import { useEffect } from "react"

import "./activeSummary.scss";
import StackBarChart from "../StackBarChart";
import useStatsStore from "../../store/stats.store";  

export default function ActiveSummary({ inputData, buttonName, title }) {

  const { graphsGroupUserStats,graphsGroupAllStats} = useStatsStore();

  const stackBarChartResumes = {
    labels : graphsGroupUserStats?.useractivity?.map((user) => user?.username ),
    datasets: [
      {
        label: 'JDs Created/Updated',
        data: graphsGroupUserStats?.useractivity?.map((user) => user?.numjdscreated+ user?.numjdsupdated ),
        backgroundColor: 'rgb(169, 204, 227  )',
      },
      {
        label: 'JDs Worked On',
        data:  graphsGroupUserStats?.useractivity?.map((user) => user?.numjdsworked ),
        backgroundColor: 'rgb(210, 180, 222)',
      },
      {
        label: 'New Uploaded',
        data: graphsGroupUserStats?.useractivity?.map((user) => user?.numuploaded ),
        backgroundColor: 'rgb(53, 162, 235)',
      },
      {
        label: 'Available',
        data: graphsGroupUserStats?.useractivity?.map((user) => user?.NumAvailable ),
        backgroundColor: 'rgb(255, 195, 0,0.5)',
      },
      {
        label: 'NP/B/JD/CB',
        data: graphsGroupUserStats?.useractivity?.map((user) => user?.numothers ),
        backgroundColor: 'rgba(128, 0, 128, 0.4)',
      },
    ],
  };   

  const stackBarChartResumeStatus = {
      labels : graphsGroupUserStats?.useractivity?.map((user) => user?.username ),
      datasets: [
        {
          label: 'Shared',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numshared ),
          backgroundColor: 'rgba(218, 247, 111, 1)',
        },
        {
          label: 'Client Feedback Pending',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numclientfbpending ),
          backgroundColor: 'rgba(111, 236, 247, 1)',
        },
        {
          label: 'Interview Rejected',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numinterviewrejected ),
          backgroundColor: 'rgba(247, 165, 111, 1)',
        },                        
        {
          label: 'ToBeShared',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numtobeshared ),
          backgroundColor: 'rgb(247, 220, 111  )',
        },
        {
          label: 'FBPending',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numfbpending ),
          backgroundColor: 'rgb(133, 193, 233)',
        },
        {
          label: 'Screen Rejected',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numscreenrejected ),
          backgroundColor: 'rgb(236, 112, 99,0.6)',
        },
        {
          label: 'Screen Selected',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numscreenselected),
          backgroundColor: 'rgba(34, 153, 84 , 0.7)',
        },
        {
          label: 'Duplicate',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numduplicates),
          backgroundColor: 'rgba(128, 128, 128,0.5)',
        }, 
        {
          label: 'Review Pending',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numreviewpending),
          backgroundColor: 'rgba(84, 153, 199)',
        },      
      ],
    }; 

 const stackBarChartResumeQuality = {
      labels : graphsGroupUserStats?.useractivity?.map((user) => user?.username ),
      datasets: [
        {
          label: 'Partial Suitable',
          data:  graphsGroupUserStats?.useractivity?.map((user) => user?.numpartialsuitable ),
          backgroundColor: 'rgba(75, 192, 192)',
        },        
        {
          label: 'Quality Resumes',
          data:  graphsGroupUserStats?.useractivity?.map((user) => user?.numgoodmatch ),
          backgroundColor: 'rgba(75, 192, 192)',
        },
        {
          label: 'Above Average',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numaboveaverage ),
          backgroundColor: 'rgb(125, 206, 160)',
        },
        {
          label: 'Average',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numaverage ),
          backgroundColor: 'rgb(133, 193, 233)',
        },
        {
          label: 'Below Average',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numbelowaverage ),
          backgroundColor: 'rgba(169, 204, 227 )',
        },
        {
          label: 'Not Suitable',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numnotsuitable ),
          backgroundColor: 'rgba(128, 128, 128,0.5)',
        },     
      ],
    }; 

  const stackBarChartInterviewSchedules = {
      labels : graphsGroupUserStats?.useractivity?.map((user) => user?.username ),
      datasets: [
        {
          label: 'L0',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numl0sch +user?.numl0resch ),
          backgroundColor: 'rgba(52, 152, 219)',
        },      
        {
          label: 'L1',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numl1sch + user?.numl1resch  ),
          backgroundColor: 'rgb(125, 206, 160)',
        },
        {
          label: 'L2',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numl2sch +  user?.numl2resch  ),
          backgroundColor: 'rgb(75, 192, 192)',
        },
        {
          label: 'Customer',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numcustomersch + user?.numcustomeresch ),
          backgroundColor: 'rgba( 88, 214, 141   )',
        },
        {
          label: 'HR',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numhrsch + user?.numhrresch  ),
          backgroundColor: 'rgba(40, 180, 99)',
        },     
      ],
    }; 

    const stackBarChartInterviewStatus = {
      labels : graphsGroupUserStats?.useractivity?.map((user) => user?.username ),
      datasets: [
        {
          label: 'L0',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numl0sch ),
          backgroundColor: 'rgba(52, 152, 219)',
        },      
        {
          label: 'L1',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numl1sch  ),
          backgroundColor: 'rgb(125, 206, 160)',
        },
        {
          label: 'L2',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numl2sch  ),
          backgroundColor: 'rgb(75, 192, 192)',
        },
        {
          label: 'Customer',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numcustomersch  ),
          backgroundColor: 'rgba( 88, 214, 141   )',
        },
        {
          label: 'HR',
          data: graphsGroupUserStats?.useractivity?.map((user) => user?.numhrsch  ),
          backgroundColor: 'rgba(40, 180, 99)',
        },     
      ],
    };     

  const alllabels = [''];
  const stackBarChartAll = {
      labels : alllabels,
      datasets: [
        {
          label: 'JDs',
          data: [graphsGroupAllStats?.numjds],
          backgroundColor: 'rgba(227, 186, 125, 0.7)',
        }, 
        {
          label: 'Resumes',
          data: [graphsGroupAllStats?.numresumes],
          backgroundColor: 'rgba(225, 100, 167, 0.7)',
        },
        {
          label: 'Vendors',
          data: [graphsGroupAllStats?.numvendors],
          backgroundColor: 'rgba(130, 224, 210, 0.7)',
        },
        {
          label: 'Users',
          data: [graphsGroupAllStats?.numusers],
          backgroundColor: 'rgba(165, 171, 0, 0.7)',
        }, 
                {
          label: 'Interviews',
          data: [graphsGroupAllStats?.numinterviews],
          backgroundColor: 'rgba(34, 153, 84 , 0.7)',
        },  
        {
          label: 'Offers',
          data: [graphsGroupAllStats?.numoffered],
          backgroundColor: 'rgba(34, 153, 84 , 0.7)',
        },  
                {
          label: 'Joined',
          data: [graphsGroupAllStats?.numjoined],
          backgroundColor: 'rgba(34, 153, 84 , 0.7)',
        },   
      ],
    }; 

  useEffect(() => {

  }, []);

  return (
        <div className="activity-summary-wrapper">
          <div className="activity-summary-title-outside">
            {(title === 'All') ? <h1 className="activity-summary-title-outside"> {title} Stats Summary </h1>
              : <h1 className="activity-summary-title-outside"> {title} Activity (Last 24 hours)</h1>
              }
          </div>

          <div className="activity-summary-main-wrapper">
              {graphsGroupUserStats != null ?
                <div className="activity-wrapper">
                    {(title === 'Users') ?
                    ( 
                    <>
                      <div className = "activity-bar-stackChart-wrapper">
                              {graphsGroupUserStats != null?
                                      graphsGroupUserStats?.graphcandidatestatus =="true"?
                                      <StackBarChart stackBarData={stackBarChartResumes} stack = {false} showTitle={"Candidate Status"} MAX = {100} />:
                                      ""
                                    :""
                              }
                              {graphsGroupUserStats != null?
                                      graphsGroupUserStats?.graphresumestatus =="true"?
                                      <StackBarChart stackBarData={stackBarChartResumeStatus} stack = {false} showTitle={"Resume Status"} MAX = {100}/>:
                                      ""
                                    :""
                              } 
                              {graphsGroupUserStats != null?
                                      graphsGroupUserStats?.graphresumescore =="true"?
                                      <StackBarChart stackBarData={stackBarChartResumeQuality} stack = {false} showTitle={"Resume Quality"} MAX = {100}/>:
                                      ""
                                    :""
                              }                                                       
                              {graphsGroupUserStats != null?
                                      graphsGroupUserStats?.graphinterviewsch =="true"?
                                      <StackBarChart stackBarData={stackBarChartInterviewSchedules} stack = {false} showTitle={"Interviews Planned"} MAX = {100}/>:
                                      ""
                                    :""
                              } 
                              {graphsGroupUserStats != null?
                                      graphsGroupUserStats?.graphinterviewstatus =="true"?
                                      <StackBarChart stackBarData={stackBarChartInterviewStatus} stack = {false} showTitle={"Interviewes Status"} MAX = {100}/>:
                                      ""
                                    :""
                              }
                              {graphsGroupUserStats != null?
                                      graphsGroupUserStats?.graphoffers =="true"?
                                      <StackBarChart stackBarData={stackBarChartInterviewStatus} stack = {false} showTitle={"Offers and Selections"} MAX = {100}/>:
                                      ""
                                    :""
                              } 
                              {graphsGroupUserStats?.useractivity == null?
                                <>No Activity </>:
                                <></>
                              }
                      </div>                               
                    </>
                    )
                    : (title === 'Vendors') ? 
                    ( 
                        <div className = "activity-bar-stackChart-wrapper">
                            <StackBarChart stackBarData={stackBarChartResumes} stack = {false} showTitle={"Candidate Status"}  MAX = {50}/>
                            <StackBarChart stackBarData={stackBarChartResumeStatus} stack = {false} showTitle={"Resume Status"}  MAX = {50}/>
                            <StackBarChart stackBarData={stackBarChartResumeQuality} stack = {false} showTitle={"Resume Quality"}  MAX = {50}/>
                            <StackBarChart stackBarData={stackBarChartInterviewStatus} stack = {false} showTitle={"Interview Status"}  MAX = {50}/>
                        </div>
                        )
                    : 
                      <></>
                    }              
                </div>
                :""
              }

          </div>
          <div className="footer-menu" style={{marginTop: "20px",fontSize:"12px",textAlign:"center"}}>
             © 2026-2027 Copyright - HMW Communications Private Limited v17-08-2026 V1 F79                                      
          </div>           
        </div>
        
    );
}
